import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { AppService, CoreProxyService, SharedCommonService, CoreTypes } from 'common-cloudstudio';
import { GearAppService } from 'common-gear';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-modal-share',
  templateUrl: './modal-share.component.html',
  styleUrls: ['./modal-share.component.css']
})
export class ModalShareComponent implements OnInit, OnDestroy {
  @ViewChild('modal', {static: true}) _modal: any;

  subscriptions: Subscription[] = []
  shareLink: string = null;
  dashboardId: number = null;
  graphicalViewId: number = null;
  assetsId: number = null
  error: string = null;
  status = 0;
  assetTrackingParameters: CoreTypes.AssetTrackingParameters =  new CoreTypes.AssetTrackingParameters();
  dashboardDescription: string = '';
  availableMobileApp: boolean = false;

  constructor(
    private router: Router, 
    public route: ActivatedRoute,
    public _appService: AppService,
    public _gearAppService: GearAppService,
    public _coreProxyService: CoreProxyService,
    private _sharedCommonService: SharedCommonService,
    private _toasterService: ToasterService
  ) {
    this.route.params.subscribe((event) => {
      if(!event){ return; }
      if(event.type === 'dashboard'){
        this.dashboardId = event.id;
      }else if(event.type === 'graphicalView'){
        this.graphicalViewId = event.id;
      }else if(event.type === 'assetsTracking'){
        this.assetsId = event.id
      }
    });
  }

  getLink() {
    this.status = 1;
    this._coreProxyService.DashboardService.ShareDashboard(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      this.dashboardId,
      this._sharedCommonService.onSetDashboardParameters?.value?.Parameters,
      this.dashboardDescription,
      this.availableMobileApp,
      res => {
        this.status = 0;
        this.dashboardDescription = '';
        let path = window.location.pathname.split('/');
        path.splice(-4, 4);
        this.shareLink = window.location.protocol + '//' 
          + window.location.hostname 
          + ((window.location.port) ? ':' + window.location.port : '')
          + path.join('/')
          + '/shared-dashboard/'
          + res;
      },
      err => {
        this.status = 2;
        this.error = err.Message;
      }
    );
  }

  getLinkView() {
    this.status = 1;
    this._coreProxyService.GraphicalViewService.ShareGraphicalViewPlan(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      this.graphicalViewId,
      this.availableMobileApp,
      res => {
        this.status = 0;
        let path = window.location.pathname.split('/');
        path.splice(-4, 4);
        this.shareLink = window.location.protocol + '//' 
          + window.location.hostname 
          + ((window.location.port) ? ':' + window.location.port : '')
          + path.join('/')
          + '/shared-view/'
          + res;
      },
      err => {
        this.status = 2;
        this.error = err.Message;
      }
    )
  }

  getLinkAssets() {
    const sharedData = this._sharedCommonService.onShareComponent.value?.data;
    if (!sharedData) { return; }
    this.status = 1;
    this.assetTrackingParameters = {
      Date:sharedData.date,
      AlarmFilters: sharedData.alarmFilters,
      AssetsIDs: sharedData.assets,
      DriversIDs:sharedData.drivers,
      GeozoneIDs: sharedData.geozones,
      ReturnRoute: sharedData.returnRoute
    };
    this._coreProxyService.AssetService.ShareAssetTracking(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      this._appService.getFacilityID(),
      this.assetTrackingParameters,
      res => {
        this.status = 0;
        let path = window.location.pathname.split('/');
        path.splice(-3, 3);
        this.shareLink = window.location.protocol + '//' 
          + window.location.hostname 
          + ((window.location.port) ? ':' + window.location.port : '')
          + path.join('/')
          + '/shared-assets/'
          + res;
      },
      err => {
        this.status = 2;
        this.error = err.Message;
      }
    )
  }
  
  ngOnInit() {
    setTimeout(() => this._modal.open(), 50);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  close() {
    setTimeout(() => this.router.navigate([{outlets: { modal: null}}]), 300);
  }

  copyToClipboard(textElement:string) {
    this._appService.copyToClipboard(textElement);
    this._toasterService.pop('info', null, this._gearAppService.GearMonitorLiterals.ShareDashboardLinkCopied)
  }
}
